import store from '@/store'
import axios from 'axios'
import {
	Message
} from 'element-ui'
import util from '@/libs/util'
import XEUtils from 'xe-utils'
import qs from 'qs';

// 创建一个错误
function errorCreate(msg) {
	const error = new Error(msg)
	errorLog(error)
	throw error
}

// 记录和显示错误
function errorLog(error) {
	// 添加到日志
	store.dispatch('d2admin/log/push', {
		message: '数据请求异常',
		type: 'danger',
		meta: {
			error
		}
	})
	// 打印到控制台
	if (process.env.NODE_ENV === 'development') {
		util.log.danger('>>>>>> Error >>>>>>')
		console.log(error)
	}
	// 显示提示
	Message({
		message: error.message,
		type: 'error',
		duration: 5 * 1000
	})
}

// 创建一个 axios 实例
const service = axios.create({
	baseURL: process.env.VUE_APP_API,
	timeout: 30000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
	config => {
		// 从本地存储中获取 JWT 令牌
		const token = util.cookies.get('jwt_token');
		if (token) {
			// 设置请求头部的 Authorization 字段
			config.headers.Authorization = `Bearer ${token}`;
		}

		// 对 GET 请求进行参数序列化，使数组能正常传递。
		if (config.method.toLowerCase() == 'get' && config.params) {
			// 移除所有空字符串、null、undefined
			Object.keys(config.params).forEach(key => {
				const value = config.params[key];
				if (value === null || value === undefined || value === '') {
					delete config.params[key];
				}
			});

			config.paramsSerializer = params => {
				return qs.stringify(params, {
					arrayFormat: 'repeat',
				});
			};
		}


		return config;
	},
	error => {
		// 发送失败
		console.log(error)
		return Promise.reject(error)
	}
)

// 响应拦截器
service.interceptors.response.use(
	(response) => {
		// 对于 blob 类型请求，返回完整响应（保留 headers）
		if (response.config.responseType === 'blob') {
			return response
		}
		// 普通请求只返回数据部分
		return response.data
	},
	async (error) => {
		if (error.response) {
			// === ⚠️ 新增对 blob 错误处理 ===
			if (
				error.response.config && error.response.config.responseType === 'blob' && typeof Blob !== 'undefined' &&
				error.response.data instanceof Blob
			) {
				// Blob 转为文本
				try {
					const text = await error.response.data.text()
					const json = JSON.parse(text)
					// 把解析到的 detail 塞回去
					error.response.data = json
				} catch (e) {
					// 非 JSON 响应保留通用错误，不能让下载错误遮蔽会话失效提示。
					error.response.data = { detail: '请求失败，请重试' }
				}
			}
			// 代理或下载接口可能返回 null/文本；错误处理不能因此跳过清理或拒绝。
			if (!error.response.data || typeof error.response.data !== 'object') error.response.data = {}
			if (error.response.status === 401) {
				if (error.response.data.detail === "Token快过期了" && !error.config._sessionRetried && !/\/(logout|token\/refresh)$/.test(error.config.url)) {
					try {
						// 发送请求以获取新的 JWT 令牌
						const response = await axios.post(process.env.VUE_APP_API + '/token/refresh', {
							// 发送用于刷新令牌的数据，例如旧的 JWT 令牌
							refresh_token: util.cookies.get('jwt_token'), // 假设你的刷新令牌存储在本地
						});
						const newToken = response.data.access_token; // 从响应中获取新的 JWT 令牌
						util.cookies.set('jwt_token', newToken); // 将新的 JWT 令牌存储到本地
						service.defaults.headers.common['Authorization'] =
							`Bearer ${newToken}`; // 更新 Axios 实例的默认请求头部
						error.config._sessionRetried = true
						error.config.baseURL = '' // 避免重复拼接 /api
						return service(error.config); // 重新发送之前失败的请求
					} catch (error) {
						await store.dispatch('d2admin/account/logout', { revoke: false })
						error.message = '登录会话已失效，请重新登录'
						errorLog(error)
						return Promise.reject(error);
					}
				} else {
					// 刷新令牌失败，可能是因为刷新令牌过期或其他原因，需要重新登录
					util.cookies.remove('jwt_token')
					util.cookies.remove('name')
					util.cookies.remove('fun_auth_keys')
					// 401 已由服务端判定失效，仅清理本地状态，避免再次调用退出接口。
					store.dispatch('d2admin/account/logout', { revoke: false })
					error.message = error.response.data.detail || '登录会话已失效，请重新登录';
					errorLog(error)
					return Promise.reject(error);
				}
			} else {
				// 根据不同的 HTTP 状态码提醒用户相应的错误信息
				switch (error.response.status) {
					case 400:
						error.message = error.response.data.detail
						break
					case 403:
						error.message = '某功能拒绝访问'
						break
					case 404:
						error.message = '请求地址出错: ' + error.response.config.url
						break
					case 408:
						error.message = '请求超时'
						break
					case 422:
						error.message = '请求参数有误: ' + (Array.isArray(error.response.data.detail) && error.response.data.detail[0] ? error.response.data.detail[0].msg : '参数格式错误')
						break
					case 500:
						error.message = '服务器内部错误: ' + error.response.data.detail
						break
					case 501:
						error.message = '服务未实现'
						break
					case 502:
						error.message = '网关错误'
						break
					case 503:
						error.message = '服务不可用'
						break
					case 504:
						error.message = '网关超时'
						break
					case 505:
						error.message = 'HTTP版本不受支持'
						break
					default:
						error.message = '请求出错：' + error.message
				}
				errorLog(error)
				return Promise.reject(error)
			}
		}
		error.message = error.message || '网络请求失败'
		errorLog(error)
		return Promise.reject(error)
	}
)

export default service
